import React from "react";
import {
	Box,
	HStack,
	Stack,
	Flex,
	Button,
	Text,
	Select,
	Checkbox,
	InputGroup,
	Input,
	InputRightElement,
	IconButton,
	Table,
	Thead,
	Tbody,
	Tfoot,
	Tr,
	Th,
	Td,
	TableCaption,
	TableContainer,
} from "@chakra-ui/react";
import {
	ChevronDownIcon,
	ArrowBackIcon,
	SearchIcon,
	ArrowDownIcon,
} from "@chakra-ui/icons";
import { HiOutlineDotsHorizontal } from "react-icons/hi";

const data = [
	{
		alertName: "Requests",
		metric: 10,
		threshold: "000",
		notification: "E-mail",
	},
	{
		alertName: "Requests",
		metric: 10,
		threshold: "000",
		notification: "E-mail",
	},
	{
		alertName: "Requests",
		metric: 10,
		threshold: "000",
		notification: "E-mail",
	},
	{
		alertName: "Requests",
		metric: 10,
		threshold: "000",
		notification: "E-mail",
	},
	{
		alertName: "Requests",
		metric: 10,
		threshold: "000",
		notification: "E-mail",
	},
	{
		alertName: "Requests",
		metric: 10,
		threshold: "000",
		notification: "E-mail",
	},
	{
		alertName: "Requests",
		metric: 10,
		threshold: "000",
		notification: "E-mail",
	},
	{
		alertName: "Requests",
		metric: 10,
		threshold: "000",
		notification: "E-mail",
	},
];

function UsageAlerts() {
	return (
		<Flex direction="column" gap={5} pt={{ base: "120px", md: "75px" }}>
			<HStack>
				<Flex align="center" gap={3}>
					<ArrowBackIcon boxSize={6} />
					<Text fontSize="2xl" fontWeight="bold">
						Usage Alerts
					</Text>
				</Flex>
			</HStack>
			<HStack justify="space-between">
				<Stack direction="row">
					<Checkbox size="lg" />
					<Select placeholder="Bulk Option">
						<option value="option1">Option 1</option>
						<option value="option2">Option 2</option>
						<option value="option3">Option 3</option>
					</Select>
					<InputGroup w="500px" ml={5}>
						<Input
							placeholder="Search"
							bg="#3D3D44"
							py="20px"
							px="24px"
							borderRadius="14px"
						/>
						<InputRightElement
							children={
								<IconButton
									bg="none"
									aria-label="Search database"
									icon={<SearchIcon />}
								/>
							}
						/>
					</InputGroup>
				</Stack>
				<Flex gap={3}>
					<Button rightIcon={<ChevronDownIcon />} bg="#48484F">
						Add Filter
					</Button>
					<Button bg="#48484F">Create Alert</Button>
				</Flex>
			</HStack>
			<TableContainer>
				<Table overflowX="auto" variant="striped">
					<Thead>
						<Tr>
							<Th></Th>
							<Th>
								Name <ArrowDownIcon />
							</Th>
							<Th>
								Metric <ArrowDownIcon />
							</Th>
							<Th>
								Threshold <ArrowDownIcon />
							</Th>
							<Th>
								Notification <ArrowDownIcon />
							</Th>
							<Th></Th>
						</Tr>
					</Thead>
					<Tbody>
						{data.map((row, index) => (
							<Tr key={index}>
								<Td>
									<Checkbox />
								</Td>
								<Td>{row.alertName}</Td>
								<Td>{row.metric}</Td>
								<Td>{row.threshold}</Td>
								<Td>{row.notification}</Td>
								<Td>
									<IconButton
										aria-label="More options"
										icon={<HiOutlineDotsHorizontal />}
										size="sm"
										variant="ghost"
									/>
								</Td>
							</Tr>
						))}
					</Tbody>
				</Table>
			</TableContainer>
		</Flex>
	);
}

export default UsageAlerts;
